import { ApiClient } from '../../client';
import {
  Manufacturer,
  CreateManufacturerRequest,
  UpdateManufacturerRequest,
  ManufacturersQueryParams,
  ManufacturerResponse,
  ManufacturerQueryResponse,
} from './types';
import { convertDatesToStrings } from '../../../../utils/dateConversion';

export class ManufacturerService {
  constructor(private api: ApiClient) {}

  async getAll(params?: ManufacturersQueryParams) {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.advancedSearch)
      queryParams.append(
        'advancedSearch',
        JSON.stringify(params.advancedSearch)
      );
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortDirection)
      queryParams.append('sortDirection', params.sortDirection);
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.offset) queryParams.append('offset', params.offset.toString());

    const query = queryParams.toString();
    const url = `/manufacturers${query ? `?${query}` : ''}`;

    return this.api.get<ManufacturerQueryResponse>(url);
  }

  async getById(id: number) {
    return this.api.get<Manufacturer>(`/manufacturers/${id}`);
  }

  async create(data: CreateManufacturerRequest) {
    const payload = convertDatesToStrings(data);
    return this.api.post<ManufacturerResponse>('/manufacturers', payload);
  }

  async update(data: UpdateManufacturerRequest) {
    const payload = convertDatesToStrings(data);
    return this.api.put<ManufacturerResponse>(
      `/manufacturers/${data.manufacturer_id}`,
      payload
    );
  }

  async delete(id: number) {
    return this.api.delete(`/manufacturers/${id}`);
  }
}
